export default {"src":"/_next/static/media/light.b12bddce.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};